import React from 'react';

export default function SpinnerLoader({ className }) {
  return (
    <div className={`col d-flex align-items-center justify-content-center ${className} Spinner-Loader`}>
      <img src="/manage/images/Rolling-1s-120px.gif" alt="loading" />
    </div>
  );
}
